/* eslint-disable @typescript-eslint/default-param-last */
import { PAINTING_SET_FORCE, PAINTING_SET_GET_FORCE_FROM_PEN, PAINTING_SET_MEDIUM } from './actions';

const initialState = {
  medium: 0,
  force: 0.5,
  getForceFromPen: true,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PAINTING_SET_MEDIUM:
      return {
        ...state,
        medium: action.payload,
      };

    case PAINTING_SET_FORCE:
      return {
        ...state,
        force: action.payload,
        getForceFromPen: false,
      };

    case PAINTING_SET_GET_FORCE_FROM_PEN:
      return {
        ...state,
        getForceFromPen: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
